// Mock data for TuriaSlides - Presentation Generator

export const mockPresentations = [
  {
    id: '1',
    title: 'Propuesta Software de Gestión',
    createdAt: '2025-01-23T10:30:00Z',
    slidesCount: 6,
    status: 'completed'
  },
  {
    id: '2',
    title: 'Plan de Marketing Digital 2025',
    createdAt: '2025-01-22T15:45:00Z',
    slidesCount: 8,
    status: 'completed'
  },
  {
    id: '3',
    title: 'Análisis de Competencia',
    createdAt: '2025-01-20T09:00:00Z',
    slidesCount: 5,
    status: 'completed'
  }
];

export const mockGeneratedSlides = [
  {
    id: 1,
    type: 'title',
    title: 'Software de Gestión Automatizada',
    subtitle: 'Propuesta para TodoPorcelanatos',
    date: '23 de enero de 2025'
  },
  {
    id: 2,
    type: 'intro',
    title: 'Introducción',
    content: 'En base a nuestro análisis detallado de sus necesidades, presentamos una solución integral a medida orientada a resolver el flujo crítico de facturación y a dotar de inteligencia la gestión de stock y logística.',
    bulletPoints: [
      'Automatización de procesos clave',
      'Integración con sistemas existentes',
      'Escalabilidad para crecimiento futuro'
    ]
  },
  {
    id: 3,
    type: 'features',
    title: 'Características Principales',
    items: [
      { icon: 'package', title: 'Gestión de Inventario', description: 'Control total de stock en tiempo real' },
      { icon: 'receipt', title: 'Facturación Automatizada', description: 'Emisión de facturas electrónicas integrada' },
      { icon: 'truck', title: 'Logística Inteligente', description: 'Optimización de rutas y entregas' },
      { icon: 'chart', title: 'Reportes Avanzados', description: 'Dashboards y métricas en tiempo real' }
    ]
  },
  {
    id: 4,
    type: 'timeline',
    title: 'Cronograma de Implementación',
    phases: [
      { phase: 'Fase 1', title: 'Análisis y Diseño', duration: '2 semanas' },
      { phase: 'Fase 2', title: 'Desarrollo Core', duration: '4 semanas' },
      { phase: 'Fase 3', title: 'Integración', duration: '2 semanas' },
      { phase: 'Fase 4', title: 'Testing y Deploy', duration: '2 semanas' }
    ]
  },
  {
    id: 5,
    type: 'pricing',
    title: 'Inversión',
    packages: [
      { name: 'Básico', price: '$2,500', features: ['Módulo Inventario', 'Soporte 8x5', '3 usuarios'] },
      { name: 'Profesional', price: '$4,500', features: ['Todo lo básico', 'Facturación', 'Soporte 24/7', '10 usuarios'], highlighted: true },
      { name: 'Enterprise', price: '$8,000', features: ['Todo profesional', 'Logística', 'API Custom', 'Usuarios ilimitados'] }
    ]
  },
  {
    id: 6,
    type: 'contact',
    title: 'Próximos Pasos',
    content: '¿Listo para transformar tu gestión empresarial?',
    contactInfo: {
      email: 'contacto@turiadesign.com',
      phone: '+34 600 123 456',
      website: 'www.turiadesign.com'
    }
  }
];

export const presentationTemplates = [
  {
    id: 'business',
    name: 'Propuesta Comercial',
    description: 'Ideal para presentar servicios y productos',
    color: '#0D9488'
  },
  {
    id: 'startup',
    name: 'Pitch Startup',
    description: 'Perfecto para inversores y demos',
    color: '#7C3AED'
  },
  {
    id: 'report',
    name: 'Informe Ejecutivo',
    description: 'Para reportes y análisis de datos',
    color: '#2563EB'
  },
  {
    id: 'creative',
    name: 'Creativo',
    description: 'Para proyectos de diseño y marketing',
    color: '#DB2777'
  }
];

export const defaultSettings = {
  apiProvider: 'claude', // 'emergent' | 'claude'
  emergentKey: '',
  claudeKey: '',
  defaultTemplate: 'business',
  maxSlides: 8,
  language: 'es'
};
